var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavigateLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 28 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.1 6.9C17.2 3 10.8 3 6.9 6.9S3 17.2 6.9 21.1s10.2 3.9 14.1 0c4-3.9 4-10.3.1-14.2m-4.6 1.2c.5.4.5 1.4-.2 2l-4 3.9 4.1 3.9c.6.6.6 1.4 0 2s-1.4.6-2 0L9.6 15c-.6-.6-.6-1.4 0-2l4.9-4.9c.3-.3.7-.4 1-.4s.6.1 1 .4",
  className: "navigate-left_svg__st0"
})));
export default SvgNavigateLeft;